import axios from 'axios';
import { createSessionAuthenticatedUrl, createUpdateAccountUrl } from './urlFactory';
import { getApiKey } from '../utils/getApiKey';

export const fetchAuthenticated = async (clientId) => {
    const apiKey = getApiKey();
    const url = createSessionAuthenticatedUrl(clientId);
    const response = await axios.get(url, {
        headers: { apiKey },
        validateStatus: (status) => status === 200 || status === 202 || status === 304 || status === 423,
    });
    return response;
};

export const updateAccount = async (clientId, payload, accountId = null) => {
    const apiKey = getApiKey();
    const url = createUpdateAccountUrl(clientId, accountId);
    const response = await axios.post(url, payload, {
        headers: { apiKey },
        validateStatus: (status) => status === 200 || status === 202 || status === 304,
    });
    console.log('updateAccount response:', response);
    return response;
};
